import type { Module } from 'vuex';
import { IndicatorOut } from '@/types/IndicatorOut';
import {RootState} from "@/store";

export interface IndicatorOutsState {
  indicatorOuts: IndicatorOut[];
}

const indicatorOutsModule: Module<IndicatorOutsState, RootState> = {
  namespaced: true,
  state: () => ({
    indicatorOuts: [],
  }),
  mutations: {
    setIndicatorOuts(state, payload: { indicatorOuts: Record<number, any> | any[] }) {
      const indicatorOuts = Array.isArray(payload.indicatorOuts)
        ? payload.indicatorOuts
        : Object.values(payload.indicatorOuts);
      state.indicatorOuts = indicatorOuts.map(raw => IndicatorOut.fromRaw(raw));
    },
    addIndicatorOut(state, payload: any) {
      state.indicatorOuts.push(IndicatorOut.fromRaw(payload));
    },
    updateIndicatorOut(state, payload: any) {
      const idx = state.indicatorOuts.findIndex(indicatorOut => indicatorOut.idIndicatorOut === payload.idIndicatorOut);
      if (idx !== -1) {
        state.indicatorOuts[idx] = IndicatorOut.fromRaw(payload);
      }
    },
    deleteIndicatorOut(state, payload: { idIndicatorOut: number }) {
      state.indicatorOuts = state.indicatorOuts.filter(indicatorOut => indicatorOut.idIndicatorOut !== payload.idIndicatorOut);
    },
  },
  actions: {
    wsSetIndicatorOuts({ commit }, payload) {
      commit('setIndicatorOuts', payload);
    },
    wsIndicatorOutCreate({ commit }, payload) {
      commit('addIndicatorOut', payload);
    },
    wsIndicatorOutUpdate({ commit }, payload) {
      commit('updateIndicatorOut', payload);
    },
    wsIndicatorOutDelete({ commit }, payload) {
      commit('deleteIndicatorOut', payload);
    },
  },
};

export default indicatorOutsModule; 